import { CancelablePromise, OpenAPI, type Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ListRequest } from "@/api/models/ListRequest";
import { ToDeleteRequest } from "@/utils/slice";
import { RechargeOrderListResponse } from "@/api/models/recharge_order/RechargeOrderListResponse";

export class RechargeOrderService {
  public static ListAll(
    body: ListRequest
  ): CancelablePromise<RechargeOrderListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/recharge/activity/order",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/recharge/activity/order",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/recharge/activity/order/drop",
      body: ToDeleteRequest(body),
    });
  }
}
